import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { TwinsAnnounce } from 'src/types/api/patentRightsApiTypes';
import { Table, TopItem, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: TwinsAnnounce;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利一案兩請關聯案件 區塊。
 */
const InfoPatentTwinsAnnounce: React.FC<Iprops> = ({
  data,
  isShow,
  setIsShow,
  colorType,
  noContent,
}) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  return (
    <DropdownInfo
      title={`專利一案兩請關聯案件`}
      isShow={isShow}
      setIsShow={setIsShow}
      color={angleColor}
    >
      <Table color={tableColor}>
        <TopItem>
          <Title>新型專利申請案號</Title>
          <Content>{data.applyNo || noContent}</Content>
        </TopItem>
      </Table>
    </DropdownInfo>
  );
};

export default InfoPatentTwinsAnnounce;
